// Entry point for the BreaksCampaign app.
// Each page feature lives in its own module under ./scripts and is started from init().

import "./styles/main.scss";
import { initCookieBannerLinks } from "./scripts/cookieBanner";
import { initHeaders } from "./scripts/header";
import { initHeroArea } from "./scripts/hero";
import { initVideoPages } from "./scripts/videoPlayer";
import { initResendLinks } from "./scripts/resendLink";
import { initFaqs } from "./scripts/faq";
import { initRankingLists } from "./scripts/rankingList";
import { initStatisticsFilters } from "./scripts/statisticsFilter";
import { initBreaksCampaignSignup } from "./scripts/signup";
import { initBreakReporting } from "./scripts/breakReporting";
import { initMunicipalityMap } from "./scripts/municipalityMap";

function init(): void {
  initCookieBannerLinks();
  initHeaders();
  initHeroArea();
  initVideoPages();
  initResendLinks();
  initFaqs();
  initRankingLists();
  initStatisticsFilters();
  initBreaksCampaignSignup();
  initBreakReporting();
  initMunicipalityMap();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
